module.exports = __webpack_public_path__ + "img/bp.0870c712.jpeg";